import { useTranslation } from 'react-i18next';
import utilities from '@/core/utilities';
import { successToast } from '@/utilities/toast.utilities';
import { faCopy } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Button } from '@seeqdev/qomponents';

export const CopyBranchCode = ({ text, branchCode }: { text: string; branchCode: string }) => {
  const { t } = useTranslation();

  const copyBranchCodeToClipboard = async (code: string) => {
    if (!code) return;

    await utilities.copyTextToClipboard(code);
    successToast({
      messageKey: 'HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_SUCCESS',
      messageParams: { branchCode: code },
    });
  };

  return (
    <div className="flexColumnContainer tw:min-w-0 tw:items-center tw:gap-1">
      <span className="flexNoShrink">{t(text)}</span>
      <span className="branchCodeHighlighting nowrap tw:min-w-0 tw:flex-initial tw:overflow-hidden tw:text-ellipsis">
        {branchCode}
      </span>
      <Button
        tooltip={t('HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_TOOLTIP')}
        icon={faCopy}
        iconStyle="text"
        variant="no-border"
        extraClassNames="sq-light-gray"
        testId="copyBranchCodeButton"
        onClick={() => copyBranchCodeToClipboard(branchCode)}
      />
    </div>
  );
};
